import { Card, CardContent } from '@/app/common/components/Card.tsx'
import { Button } from '@/app/common/components/button/Button.tsx'
import { CircleCheck } from 'lucide-react'

export default function RuleSuccess({
  onViewRuleClick,
}: {
  onViewRuleClick: () => void
}) {
  return (
    <div className="w-full px-3 py-12 sm:px-6 lg:px-8 flex justify-center">
      <Card className="max-w-lg text-center">
        <CardContent className="space-y-6 py-10">
          <div className="flex justify-center">
            <CircleCheck
              className="h-12  w-12 text-green-600"
              aria-hidden="true"
            />
          </div>

          <div>
            <h2 className="text-lg font-semibold text-gray-900">
              Your Program Rule Was Successfully Created
            </h2>
            <p className="mt-2 text-sm text-gray-600">
              Your program rule has been saved and is now live. View details or
              create additional rules in your purse settings.
            </p>
          </div>

          <div>
            <Button type="button" variant="primary" onClick={onViewRuleClick}>
              View Rule
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
